module.exports = __webpack_public_path__ + "img/service.dedcd2e4.png";